import { configureStore } from '@reduxjs/toolkit';
import loginSlice from './login.slice';
import { apiSlice } from '../api/apiSlice';
import testSlice from './test.slice';
export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    user: loginSlice,
    test: testSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(apiSlice.middleware),
});